module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-start-selling-headphones@2x-df77efde870c3df88645299fec01f455.png";